import {Component, Output, EventEmitter, AfterContentInit} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MedicationFamily } from 'src/app/models/medicationfamily';
import { ValidationResult } from 'src/app/models/validation-result';
import { MedicationService } from 'src/app/services/medication.service';
import { TransactionHistoryService } from 'src/app/services/transactionhistory.service';
import { DwUtils } from '../utils/dw-utils';

@Component({
	selector: 'app-quickadd-medfamily',
	templateUrl: './quickadd-medfamily.component.html',
	styleUrls: ['./quickadd-medfamily.component.css']
})
export class QuickaddMedfamilyComponent implements AfterContentInit {

	disabledFlag = false;
	isEditing = true;
	public strErr: string | null = '';
	public id: any | null = '';
	public description: any | null = '';
	public itemPrefix: any | null = '';
	public invWarningThreshold: number | null = 0;
	public expirationGraceDays: number | null = 0;
	public schedule: string | null = '0';
	public valStatus: any;
	@Output() submitClicked = new EventEmitter();
	@Output() cancelClicked = new EventEmitter();
	selectedRecord: MedicationFamily;

	constructor(private medicationService: MedicationService, private txService: TransactionHistoryService,
		public dialog: MatDialog) {
		this.selectedRecord = new MedicationFamily();
	}
	ngAfterContentInit() {
		DwUtils.setFocus('item_prefix');
	}

	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}

		return true;
	}
	clear() {
		this.description = '';
		this.invWarningThreshold = 0;
		this.expirationGraceDays = 0;
		this.schedule = '0';
		this.id = 0;
	}

	public setRecord(): void {
		this.selectedRecord = new MedicationFamily();
		this.selectedRecord.id = 0;
		this.selectedRecord.description = String(this.description).toUpperCase();
		this.selectedRecord.itemPrefix = this.itemPrefix;
		this.selectedRecord.invWarningThreshold = this.invWarningThreshold;
		this.selectedRecord.expirationGraceDays = this.expirationGraceDays;
		this.selectedRecord.activeStatus = 'Active';
		this.selectedRecord.schedule = this.schedule;
	}
	public checkUniqueItemPrefix() {

		this.strErr = '';
		if ((this.itemPrefix === undefined) || (this.itemPrefix === '')) {
			return;
		}
		this.medicationService.getMedicationFamilyByItemPrefix(this.itemPrefix).subscribe(
			(data) => {
				if (data !== null) {
					this.strErr = 'Error: this Item Prefix (Pres-Core) is in use - please choose a' +
						' unique code';
					DwUtils.highlightFocus('item_prefix');
				}
			},
			(error) => {
				console.log(error);
			});
	}
	public doItemPrefixHint(): void {

		this.medicationService.getNextItemPrefixNumber().subscribe(
			(data) => {
				this.itemPrefix = data;
				DwUtils.setFocus('description');
			});
	}
	public submitRecord() {

		this.setRecord();
		this.strErr = '';

		if (!this.validateFields()) {
			return;
		}
		this.medicationService.createMedicationFamily(this.selectedRecord).subscribe(
			(data) => {
				if (data === undefined || data === null) {
					return;
				}
				this.selectedRecord.id = data.id;
				this.clear();
				/*** add a transaction history record ***/
				this.txService.createTransactionHistory('medication-family', this.selectedRecord.id);
				this.submitClicked.emit(data);
			},
			(error) => {
				this.strErr = 'Error: The server could not add/submit this record';
				return;
			}
		);

	}
	public cancelSubmitRecord() {
		this.strErr = '';
		this.cancelClicked.emit();
	}
	public addLeadingZero(event: any) {
		// get maxlength attr
		const maxLength = parseInt(event.target.getAttribute("maxlength"));
		// "0".repeat(maxLength) <-- create default pad with maxlength given
		// append zero and slice last of attr maxlength value
		const newValue = ("0".repeat(maxLength) + event.target.value.toString()).slice(-maxLength);
		// change the value of input
		event.target.value = newValue;
	}
	public pad(num: number, size: number): string {
		let s = num + "";
		while (s.length < size) s = "0" + s;
		return s;
	}

}



